import { FaInfoCircle } from 'react-icons/fa';

const Home = () => {
  return (
    <section style={styles.section}>
      <h2 style={styles.title}>About Us</h2>
      <p style={styles.description}>
        <span style={styles.highlight}>Lepronth</span>  is a forward-thinking IT company dedicated to providing innovative digital solutions for businesses of all scales. Our goal is to equip companies with advanced technology, helping them reach their objectives with maximum efficiency and effectiveness.
      </p>
      <p style={styles.description}>
        Backed by years of industry expertise, we have established a strong reputation for quality, dependability, and customer satisfaction. Our skilled professionals take a personalized approach, identifying each client's specific challenges and developing customized solutions that foster growth and success.
      </p>
      <p style={styles.description}>
        At Lepronth, we stay at the forefront of technological advancements, constantly refining our strategies to deliver the most secure and efficient IT solutions. Our core principles are built on innovation, integrity, and an unwavering dedication to excellence.
      </p>
      <p style={styles.description}>
        Whether you're a startup aiming to build a strong digital foundation or a well-established company looking to enhance operations, we are ready to support you at every stage of your journey.
      </p>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#000',
    color: '#fff',
    padding: '60px 20px',
    textAlign: 'center',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    maxWidth: '800px',
    margin: '0 auto 20px',
    lineHeight: '1.6',
  },
  highlight: {
    color: '#01a300',
    fontWeight: 'bold',
  },
};

export default Home;
